/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `40HC` - 40HC
 * * `20DC` - 20DC
 * * `20RE` - 20RE
 * * `20TK` - 20TK
 * * `40DC` - 40DC
 * * `40RH` - 40RH
 * * `CURTAIN_SIDE` - Curtain Side
 */
export type ContainerTypeEnum = typeof ContainerTypeEnum[keyof typeof ContainerTypeEnum];


export const ContainerTypeEnum = {
  '40HC': '40HC',
  '20DC': '20DC',
  '20RE': '20RE',
  '20TK': '20TK',
  '40DC': '40DC',
  '40RH': '40RH',
  CURTAIN_SIDE: 'CURTAIN_SIDE',
} as const;
